import countryNamesWithCodes from './countryNamesWithCodes';

export const getCountryLabelFromValue: (
	code?: string,
	countries?: any[]
) => string = (code = 'gb', countries) => {
	const data = countries || countryNamesWithCodes;
	return data.find(country => country.value === code)?.label;
};
